import { useTranslation } from "react-i18next";
import { FOOT } from "../styles";
import { CommandButton } from "./CommandButton";

type Props = {
  confirmReset: boolean;
  onAskReset: () => void;
  onCancelReset: () => void;
  onConfirmReset: () => void;
};

/** Reset sits below a full-width divider, outside the split, behind a two-step confirm. */
export function DockFooter({
  confirmReset,
  onAskReset,
  onCancelReset,
  onConfirmReset,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className={FOOT}>
      {confirmReset ? (
        <span className="flex flex-wrap items-center gap-[8px]">
          <span className="text-[11px] font-medium text-[#FFB4A8]">{t("HeadsetDock.ResetQuestion")}</span>
          <CommandButton size="foot" tone="yes" onClick={onConfirmReset}>
            {t("HeadsetDock.ResetConfirm")}
          </CommandButton>
          <CommandButton size="foot" tone="ghost" onClick={onCancelReset}>
            {t("Cancel")}
          </CommandButton>
        </span>
      ) : (
        <CommandButton size="foot" tone="danger" onClick={onAskReset}>
          {t("HeadsetDock.ResetExperience")}
        </CommandButton>
      )}
    </div>
  );
}
